/**
 * Iter-60 — Generic mobile record card.
 *
 * Small composable primitive for showing key/value pairs of a record on
 * mobile. Rows adapt gracefully; long values truncate.
 */
import React from "react";

export function MobileRecordCard({ children, onClick, testId }) {
  const Tag = onClick ? "button" : "div";
  return (
    <Tag
      type={onClick ? "button" : undefined}
      onClick={onClick}
      data-testid={testId}
      className={
        "block w-full text-left border border-black bg-white p-3 " +
        (onClick ? "hover:bg-yellow-50 active:translate-x-[1px] active:translate-y-[1px]" : "")
      }
    >
      {children}
    </Tag>
  );
}

export function MobileRecordRow({ label, value, testId }) {
  return (
    <div className="flex items-baseline gap-3 py-0.5" data-testid={testId}>
      <span className="text-[10px] font-mono uppercase tracking-widest text-zinc-500 w-24 flex-shrink-0">
        {label}
      </span>
      <span className="text-sm text-zinc-800 truncate min-w-0 flex-1">{value}</span>
    </div>
  );
}

export function MobileRecordHeader({ title, badge = null }) {
  return (
    <div className="flex items-center gap-2 mb-1 pb-1 border-b border-zinc-200">
      <div className="font-bold text-sm truncate flex-1">{title}</div>
      {badge}
    </div>
  );
}

export default MobileRecordCard;
